import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { GradingScheme } from './grading-scheme.model';

export class GradingSchemeStateModel extends EntityStateModel<GradingScheme> {
    rule?: string;
}
